<form [formGroup]="form" class="k-form" id="custom-hunt-package">
  <div class="input-container">
    @if (isEditing) {
      <hyperkit-input
        formControlName="title"
        type="text"
        class="text-input"
        placeholder="Title"
        [maxLength]="50"
      ></hyperkit-input>
      <div class="button-container">
        <hyperkit-button
          size="small"
          color="secondary"
          text="Cancel"
          (click)="closeDrawer()"
        ></hyperkit-button>
        <hyperkit-button
          size="small"
          color="tertiary"
          text="Save"
          [disabled]="form.invalid"
          (click)="onSave()"
        ></hyperkit-button>
      </div>
    } @else {
      <hyperkit-typography variant="h1" align="left" color="primary">{{
        customContent?.title
      }}</hyperkit-typography>
      <div class="button-container">
        <hyperkit-button
          size="small"
          color="tertiary"
          text="Edit"
          (click)="editContent()"
        ></hyperkit-button>
      </div>
    }
  </div>
  <kendo-drawer-container>
    <kendo-drawer
      #drawer
      [items]="items"
      mode="push"
      [mini]="true"
      [expanded]="true"
      [autoCollapse]="false"
      (select)="onSelect($event)"
    >
    </kendo-drawer>

    <kendo-drawer-content>
      <div class="drawer-content">
        <div class="header">
          <hyperkit-typography variant="h3" align="center" color="primary">{{
            selectedSection
          }}</hyperkit-typography>
        </div>
        <div class="custom-content">
          @if (!isEditing) {
            @if (customContent) {
              <div class="custom-content">
                @switch (selectedSection) {
                  @case ('Hunt Queries') {
                    <div class="huntQueries">
                      @for (
                        record of customContent.content.records;
                        track record
                      ) {
                        <cyborg-content
                          [content]="record"
                          [huntPackage]="customContent"
                          type="hunt-package"
                        >
                        </cyborg-content>
                      } @empty {
                        <hyperkit-typography
                          variant="body"
                          size="sm"
                          align="left"
                          color="body"
                          >No tools to display
                        </hyperkit-typography>
                      }
                    </div>
                  }
                  @case ('Overview') {
                    <div>
                      <kendo-form>
                        <kendo-form-field>
                          <kendo-label for="hunt-category"
                            >Hunt Category</kendo-label
                          >
                          <hyperkit-typography
                            variant="body"
                            size="sm"
                            align="left"
                            color="body"
                            >{{
                              displayValue(
                                toLabel(customContent?.hunt_category)
                              )
                            }}
                          </hyperkit-typography>
                        </kendo-form-field>
                        <kendo-form-field>
                          <kendo-label for="description"
                            >Description</kendo-label
                          >
                          <hyperkit-typography
                            variant="body"
                            size="sm"
                            align="left"
                            color="body"
                            >{{ displayValue(customContent.description) }}
                          </hyperkit-typography>
                        </kendo-form-field>
                        <div class="form-row">
                          <kendo-form-field>
                            <kendo-label for="threatNames"
                              >Threat Names</kendo-label
                            >
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                            >
                              {{
                                displayValue(
                                  customContent.context.threat_names?.join(', ')
                                )
                              }}
                            </hyperkit-typography>
                          </kendo-form-field>
                          <kendo-form-field>
                            <kendo-label for="actors">Actors</kendo-label>
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                              >{{
                                displayValue(
                                  customContent.context.actors?.join(', ')
                                )
                              }}</hyperkit-typography
                            >
                          </kendo-form-field>
                        </div>
                        <div class="form-row">
                          <kendo-form-field>
                            <kendo-label for="diamondModel"
                              >Diamond Models</kendo-label
                            >
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                            >
                              {{
                                displayValue(
                                  customContent.mapping.diamond_model
                                )
                              }}
                            </hyperkit-typography>
                          </kendo-form-field>
                          <kendo-form-field>
                            <kendo-label for="targetOses"
                              >Target Oses</kendo-label
                            >
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                            >
                              {{
                                displayValue(
                                  customContent.context.target_oses?.join(', ')
                                )
                              }}
                            </hyperkit-typography>
                          </kendo-form-field>
                        </div>
                        <div class="form-row">
                          <kendo-form-field>
                            <kendo-label for="dependencies"
                              >Dependencies</kendo-label
                            >
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                              >{{
                                displayValue(
                                  customContent.dependencies?.join(', ')
                                )
                              }}
                            </hyperkit-typography>
                          </kendo-form-field>
                        </div>
                        <div class="form-row">
                          <kendo-form-field>
                            <kendo-label for="severity">Severity</kendo-label>
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                              >{{ displayValue(customContent.severity) }}
                            </hyperkit-typography>
                          </kendo-form-field>
                          <kendo-form-field>
                            <kendo-label for="threatCategories"
                              >Threat Categories</kendo-label
                            >
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                              >{{
                                displayValue(
                                  customContent.context.threat_categories?.join(
                                    ', '
                                  )
                                )
                              }}
                            </hyperkit-typography>
                          </kendo-form-field>
                        </div>
                        <div class="form-row">
                          <kendo-form-field>
                            <kendo-label>Kill Chains</kendo-label>
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                              >{{
                                displayValue(
                                  customContent.mapping?.kill_chains?.join(', ')
                                )
                              }}
                            </hyperkit-typography>
                          </kendo-form-field>
                        </div>
                        <div class="form-row">
                          <kendo-form-field>
                            <kendo-label>Tactic</kendo-label>
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                              >{{ uniqueTactics }}
                            </hyperkit-typography>
                          </kendo-form-field>
                        </div>
                        <div class="form-row">
                          <kendo-form-field>
                            <kendo-label>Technique</kendo-label>
                            <hyperkit-typography
                              variant="body"
                              size="sm"
                              align="left"
                              color="body"
                              >{{
                                displayValue(
                                  customContent.mapping?.mitre?.mitre_attack_techniques.join(
                                    ',  '
                                  )
                                )
                              }}
                            </hyperkit-typography>
                          </kendo-form-field>
                        </div>
                        <div class="form-row">
                          <kendo-form-field>
                            <kendo-label>Technique ID</kendo-label>
                            @for (
                              id of customContent?.mapping?.mitre
                                ?.mitre_attack_technique_ids;
                              track id;
                              let isLast = $last
                            ) {
                              <div>
                                <hyperkit-link
                                  variant="emphasized"
                                  size="sm"
                                  href="https://attack.mitre.org/techniques/{{
                                    id.replace('.', '/')
                                  }}"
                                  display="inline"
                                  align="left"
                                  color="primary"
                                  text="{{ id }}"
                                ></hyperkit-link>
                                @if (!isLast) {
                                  <span>, &nbsp;</span>
                                }
                              </div>
                            }
                          </kendo-form-field>
                        </div>
                      </kendo-form>
                    </div>
                  }
                  @case ('Research') {
                    <div>
                      <kendo-form-field>
                        <kendo-label for="analystNotes"
                          >Analyst Notes</kendo-label
                        >
                        <hyperkit-markdown
                          [md]="
                            displayValue(
                              customContent.running_analyst_notes?.[0]
                                ?.current_analyst_note
                            )
                          "
                        ></hyperkit-markdown>
                      </kendo-form-field>
                      <kendo-form-field>
                        <kendo-label for="threatDescription"
                          >Threat Description</kendo-label
                        >
                        <hyperkit-markdown
                          [md]="
                            displayValue(
                              customContent.context.threat_description
                            )
                          "
                        ></hyperkit-markdown>
                      </kendo-form-field>
                    </div>
                  }
                  @case ('References') {
                    <div>
                      <kendo-form-field>
                        <kendo-label>General</kendo-label>
                        @for (
                          ref of customContent.references.general;
                          track ref
                        ) {
                          <hyperkit-link
                            variant="body"
                            size="sm"
                            href="{{ ref }}"
                            align="left"
                            color="secondary"
                            text="{{ ref }}"
                          ></hyperkit-link>
                        } @empty {
                          <hyperkit-typography
                            variant="body"
                            align="left"
                            color="body"
                            >--</hyperkit-typography
                          >
                        }
                      </kendo-form-field>
                      <kendo-form-field>
                        <kendo-label>Analysis</kendo-label>
                        @for (
                          ref of customContent.references.analysis;
                          track ref
                        ) {
                          <hyperkit-link
                            variant="body"
                            size="sm"
                            href="{{ ref }}"
                            align="left"
                            color="secondary"
                            text="{{ ref }}"
                          ></hyperkit-link>
                        } @empty {
                          <hyperkit-typography
                            variant="body"
                            align="left"
                            color="body"
                            >--</hyperkit-typography
                          >
                        }
                      </kendo-form-field>
                      <kendo-form-field>
                        <kendo-label>Blog Links</kendo-label>
                        @for (
                          ref of customContent.references.blog_links;
                          track ref
                        ) {
                          <hyperkit-link
                            variant="body"
                            size="sm"
                            href="{{ ref }}"
                            align="left"
                            color="secondary"
                            text="{{ ref }}"
                          ></hyperkit-link>
                        } @empty {
                          <hyperkit-typography
                            variant="body"
                            align="left"
                            color="body"
                            >--</hyperkit-typography
                          >
                        }
                      </kendo-form-field>
                      <kendo-form-field>
                        <kendo-label>Malware Samples</kendo-label>
                        @for (
                          ref of customContent.references.malware_samples;
                          track ref
                        ) {
                          <hyperkit-link
                            variant="body"
                            size="sm"
                            href="{{ ref }}"
                            align="left"
                            color="secondary"
                            text="{{ ref }}"
                          ></hyperkit-link>
                        } @empty {
                          <hyperkit-typography
                            variant="body"
                            align="left"
                            color="body"
                            >--</hyperkit-typography
                          >
                        }
                      </kendo-form-field>
                    </div>
                  }
                  @case ('Response Actions') {
                    <div>
                      <kendo-form-field>
                        <kendo-label for="analystRunbook"
                          >Analyst Runbook</kendo-label
                        >
                        <hyperkit-markdown
                          [md]="
                            displayValue(
                              customContent.response_actions.analyst_runbook
                            )
                          "
                        ></hyperkit-markdown>
                      </kendo-form-field>
                      <kendo-form-field>
                        <kendo-label for="mitigationRecommendations"
                          >Migitation Recommendations</kendo-label
                        >
                        <hyperkit-markdown
                          [md]="
                            displayValue(
                              customContent.response_actions
                                .mitigation_recommendations
                            )
                          "
                        ></hyperkit-markdown>
                      </kendo-form-field>
                    </div>
                  }
                }
              </div>
            }
          } @else {
            <div class="custom-content">
              @switch (selectedSection) {
                @case ('Hunt Queries') {
                  <div class="huntQueries">
                    <div formArrayName="tools">
                      @for (
                        tool of toolsFormArray.controls;
                        track tool;
                        let i = $index
                      ) {
                        <div>
                          <kendo-card width="600px">
                            <kendo-card-body>
                              <ng-container [formGroupName]="i">
                                <kendo-formfield>
                                  <kendo-label
                                    for="toolType"
                                    text="Tool"
                                  ></kendo-label>
                                  <kendo-dropdownlist
                                    #product
                                    formControlName="toolType"
                                    [style.width]="'100%'"
                                    [data]="groupedData"
                                    textField="name"
                                    valueField="name"
                                    [valuePrimitive]="true"
                                  >
                                    <ng-template
                                      kendoDropDownListItemTemplate
                                      let-dataItem
                                    >
                                      <img
                                        width="20px"
                                        [src]="getToolIcon(dataItem.name)"
                                      />
                                      {{ dataItem.name }}
                                    </ng-template>
                                  </kendo-dropdownlist>
                                </kendo-formfield>
                                <hyperkit-tab-bar
                                  variant="secondary"
                                  mode="underline"
                                >
                                  <hyperkit-tab text="Queries">
                                    <hyperkit-input
                                      formControlName="queryTitle"
                                      type="text"
                                      placeholder="Title"
                                      [maxLength]="50"
                                      label="Query Title"
                                    ></hyperkit-input>
                                    <hyperkit-multiselect
                                      label="Category"
                                      displayProperty="name"
                                      valueProperty="category"
                                      [options]="categoryData"
                                      formControlName="categories"
                                    >
                                    </hyperkit-multiselect>
                                    <hyperkit-textarea
                                      label="Query"
                                      formControlName="query"
                                    >
                                    </hyperkit-textarea>
                                  </hyperkit-tab>
                                  <hyperkit-tab text="Deployment Requirements">
                                    <hyperkit-textarea
                                      label="Deployment Steps"
                                      formControlName="deploymentSteps"
                                    >
                                    </hyperkit-textarea>
                                  </hyperkit-tab>
                                </hyperkit-tab-bar>
                                <hyperkit-button
                                  size="small"
                                  color="tertiary"
                                  variant="icon"
                                  icon="trash"
                                  (click)="removeTool(i)"
                                ></hyperkit-button>
                              </ng-container>
                            </kendo-card-body>
                          </kendo-card>
                        </div>
                      }
                    </div>
                    <div class="k-form-buttons">
                      <hyperkit-button
                        size="small"
                        color="tertiary"
                        text="New Tool"
                        (click)="addTool()"
                      ></hyperkit-button>
                    </div>
                  </div>
                }
                @case ('Overview') {
                  <div>
                    @if (tags$ | async; as tags) {
                      <kendo-form>
                        <div class="form-row">
                          <hyperkit-select
                            label="Hunt Category"
                            [options]="categoryOptions"
                            [displayProperty]="'text'"
                            [valueProperty]="'id'"
                            formControlName="huntCategory"
                            hint="Used to support pivoting"
                            dropdownPosition="absolute"
                          ></hyperkit-select>
                          <hyperkit-textarea
                            label="Description"
                            placeholder="Enter the hunt package description"
                            formControlName="description"
                          >
                          </hyperkit-textarea>
                        </div>
                        <div class="form-row">
                          <hyperkit-multiselect
                            label="Threat Names"
                            [options]="tags.threat_names"
                            formControlName="threatNames"
                          >
                          </hyperkit-multiselect>
                          <hyperkit-multiselect
                            label="Actors"
                            [options]="tags.actors"
                            formControlName="actors"
                          >
                          </hyperkit-multiselect>
                        </div>
                        <div class="form-row">
                          <hyperkit-multiselect
                            label="Diamond Models"
                            [options]="tags.diamond_models"
                            formControlName="diamondModel"
                          >
                          </hyperkit-multiselect>
                          <hyperkit-multiselect
                            label="Target Oses"
                            [options]="tags.target_oses"
                            formControlName="targetOses"
                          >
                          </hyperkit-multiselect>
                        </div>
                        <div class="form-row">
                          <hyperkit-multiselect
                            label="Dependencies"
                            [options]="tags.dependencies"
                            formControlName="dependencies"
                          >
                          </hyperkit-multiselect>
                        </div>
                        <div class="form-row">
                          <hyperkit-select
                            label="Severity"
                            [options]="tags?.severities"
                            formControlName="severity"
                            placeholder="Select"
                            dropdownPosition="absolute"
                          ></hyperkit-select>
                          <hyperkit-multiselect
                            label="Threat Categories"
                            [options]="tags.threat_categories"
                            formControlName="threatCategories"
                          >
                          </hyperkit-multiselect>
                        </div>
                        <div class="form-row">
                          <hyperkit-multiselect
                            label="Kill Chains"
                            [options]="tags.kill_chains"
                            formControlName="killChains"
                          >
                          </hyperkit-multiselect>
                        </div>
                        <kendo-form-field>
                          <kendo-label>MITRE</kendo-label>
                          <mitre-multiselect
                            formControlName="mitre"
                            [options]="groupedMITRE"
                            (valueChange)="onMITREChange($event)"
                          ></mitre-multiselect>
                        </kendo-form-field>
                      </kendo-form>
                    }
                  </div>
                }
                @case ('Research') {
                  <div>
                    <kendo-form-field>
                      <kendo-label for="analystNotes"
                        >Analyst Notes</kendo-label
                      >
                      <quill-editor
                        [modules]="editorOptions"
                        id="analystNotes"
                        formControlName="analystNotes"
                      >
                      </quill-editor>
                    </kendo-form-field>
                    <kendo-form-field>
                      <kendo-label for="threatDescription"
                        >Threat Description</kendo-label
                      >
                      <quill-editor
                        [modules]="editorOptions"
                        id="threatDescription"
                        formControlName="threatDescription"
                      >
                      </quill-editor>
                    </kendo-form-field>
                  </div>
                }
                @case ('References') {
                  <div>
                    <hyperkit-accordion title="General" [expanded]="false">
                      <div class="content">
                        <div formArrayName="general">
                          @for (
                            link of generalLinksFormArray.controls;
                            track link;
                            let i = $index
                          ) {
                            <div class="link-field">
                              <hyperkit-input
                                [formControlName]="i"
                                placeholder="https://example.com"
                                type="text"
                                class="text-input"
                              ></hyperkit-input>
                              <hyperkit-button
                                size="small"
                                color="tertiary"
                                variant="icon"
                                icon="trash"
                                (click)="removeGeneralLink(i)"
                              ></hyperkit-button>
                            </div>
                          }
                        </div>
                        <hyperkit-button
                          size="small"
                          color="tertiary"
                          variant="standard"
                          text="Add Link"
                          icon="plus"
                          (click)="addEmptyGeneralLink()"
                          [disabled]="!canAddNewLink()"
                        ></hyperkit-button>
                      </div>
                    </hyperkit-accordion>
                    <hyperkit-accordion title="Analysis" [expanded]="false">
                      <div class="content">
                        <div formArrayName="analysis">
                          @for (
                            link of analysisLinksFormArray.controls;
                            track link;
                            let i = $index
                          ) {
                            <div class="link-field">
                              <hyperkit-input
                                [formControlName]="i"
                                placeholder="https://example.com"
                                type="text"
                                class="text-input"
                              ></hyperkit-input>
                              <hyperkit-button
                                size="small"
                                color="tertiary"
                                variant="icon"
                                icon="trash"
                                (click)="removeAnalysisLink(i)"
                              ></hyperkit-button>
                            </div>
                          }
                        </div>
                        <hyperkit-button
                          size="small"
                          color="tertiary"
                          variant="standard"
                          text="Add Link"
                          icon="plus"
                          (click)="addEmptyAnalysisLink()"
                          [disabled]="!canAddNewAnalysisLink()"
                        ></hyperkit-button>
                      </div>
                    </hyperkit-accordion>
                    <hyperkit-accordion title="Blog Links" [expanded]="false">
                      <div class="content">
                        <div formArrayName="blogLinks">
                          @for (
                            link of linksFormArray.controls;
                            track link;
                            let i = $index
                          ) {
                            <div class="link-field">
                              <hyperkit-input
                                [formControlName]="i"
                                placeholder="https://example.com"
                                type="text"
                                class="text-input"
                              ></hyperkit-input>
                              <hyperkit-button
                                size="small"
                                color="tertiary"
                                variant="icon"
                                icon="trash"
                                (click)="removeLink(i)"
                              ></hyperkit-button>
                            </div>
                          }
                        </div>
                        <hyperkit-button
                          size="small"
                          color="tertiary"
                          variant="standard"
                          text="Add Link"
                          icon="plus"
                          (click)="addEmptyBlogLink()"
                          [disabled]="!canAddNewBlogLink()"
                        ></hyperkit-button>
                      </div>
                    </hyperkit-accordion>
                    <hyperkit-accordion
                      title="Malware Samples"
                      [expanded]="false"
                    >
                      <div class="content">
                        <div formArrayName="malwareSamples">
                          @for (
                            link of malwareLinksFormArray.controls;
                            track link;
                            let i = $index
                          ) {
                            <div class="link-field">
                              <hyperkit-input
                                [formControlName]="i"
                                placeholder="https://example.com"
                                type="text"
                                class="text-input"
                              ></hyperkit-input>
                              <hyperkit-button
                                size="small"
                                color="tertiary"
                                variant="icon"
                                icon="trash"
                                (click)="removeMalwareLink(i)"
                              ></hyperkit-button>
                            </div>
                          }
                        </div>
                        <hyperkit-button
                          size="small"
                          color="tertiary"
                          variant="standard"
                          text="Add Link"
                          icon="plus"
                          (click)="addEmptyMalwareLink()"
                          [disabled]="!canAddNewMalwareLink()"
                        ></hyperkit-button>
                      </div>
                    </hyperkit-accordion>
                  </div>
                }
                @case ('Response Actions') {
                  <div>
                    <kendo-form-field>
                      <kendo-label for="analystRunbook"
                        >Analyst Runbook</kendo-label
                      >
                      <quill-editor
                        [modules]="editorOptions"
                        id="analystRunbook"
                        formControlName="analystRunbook"
                      >
                      </quill-editor>
                    </kendo-form-field>
                    <kendo-form-field>
                      <kendo-label for="mitigationRecommendations"
                        >Mitigation Recommedations</kendo-label
                      >
                      <quill-editor
                        [modules]="editorOptions"
                        id="mitigationRecommendations"
                        formControlName="mitigationRecommendations"
                      >
                      </quill-editor>
                    </kendo-form-field>
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    </kendo-drawer-content>
  </kendo-drawer-container>
</form>
<ng-template #loading>
  <p>Loading…</p>
</ng-template>
